import BaseProductViewModel from "@/models/Products/ProductViewModel";

export default class EditProductViewModel extends BaseProductViewModel {
    updatedAt: Date;
}